export const fmtNumber = (n: number) => {
    if (n < 1000) return n;
    if (n < 1000000) return Math.ceil(n / 1000) + 'K';
    if (n < 1000000000) return Math.ceil(n / 1000000) + 'M' + Math.ceil(n / 1000) + 'K';
    if (n < 1000000000000) return Math.ceil(n / 1000000000) + 'G' + Math.ceil(n / 1000000) + 'M';
    return '∞';

}

export const cal_expire_in=(ex:number) =>{
    if (ex<1 || ex>6)
         return 7200 //2*3600

    switch(ex){
        case 1:
            return 7200 //2*60
        case 2:
            return 14400 //4*3600 #4
        case 3:
            return 86400 //24*3600 #24*60
        case 4:
            return 259200 //3*24*3600 #24*60*3
        case 5:
            return 604800 //7*24*3600 
        case 6:
            return 2592000 //30*24*3600
    }

}

export function shortTime(time: Date | string | number): string {
    // 将输入的时间转换为Date对象
    let date: Date;
    if (typeof time === 'string') {
        date = new Date(time);
    } else if (typeof time === 'number') {
        date = new Date(time*1000);
    } else {
        date = time;
    }

    // 获取当前时间
    const now = new Date();

    // 计算时间差（以毫秒为单位）
    const diff = now.getTime() - date.getTime();

    // 定义时间单位的转换关系
    const minute = 60 * 1000; // 1分钟的毫秒数
    const hour = 60 * minute; // 1小时的毫秒数
    const day = 24 * hour; // 1天的毫秒数
    const week = 7 * day; // 1周的毫秒数
    const month = 30 * day; // 1个月的毫秒数（近似）
    const year = 365 * day; // 1年的毫秒数（近似）

    // 获取时间的年月日
    const yearNow = now.getFullYear();
    const monthNow = now.getMonth();
    const dayNow = now.getDate();
    const yearTime = date.getFullYear();
    const monthTime = date.getMonth();
    const dayTime = date.getDate();

    // 判断是过去时间还是未来时间
    if (diff >= 0) {
        // 过去时间
        if (diff < minute) {
            const seds = Math.floor(diff/1000);
            return `${seds}秒前`;
        } else if (diff < hour) {
            const minutes = Math.floor(diff / minute);
            return `${minutes}分钟前`;
        } else if (diff < day) {
            const hours = Math.floor(diff / hour);
            return `${hours}小时前`;
        } else if (yearTime === yearNow) {
            if (monthTime === monthNow) {
                if (dayTime === dayNow) {
                    return date.toLocaleTimeString(); // 当天不显示年月日
                } else {
                    return date.toLocaleTimeString('zh-CN', { hour: '2-digit', minute: '2-digit', second: '2-digit', day: '2-digit' }); // 当月不显示年月
                }
            } else {
                return date.toLocaleTimeString('zh-CN', { hour: '2-digit', minute: '2-digit', second: '2-digit', month: '2-digit', day: '2-digit' }); // 当年不显示年
            }
        } else {
            return date.toLocaleTimeString('zh-CN', { hour: '2-digit', minute: '2-digit', second: '2-digit', year: 'numeric', month: '2-digit', day: '2-digit' }); // 其他情况显示完整日期时间
        }
    } else {
        // 未来时间
        const absDiff = Math.abs(diff);
        if (absDiff < minute) {
            const seds = Math.floor(absDiff/1000);
            return `${seds}秒后`;
        } else if (absDiff < hour) {
            const minutes = Math.floor(absDiff / minute);
            return `${minutes}分钟后`;
        } else if (absDiff < day) {
            const hours = Math.floor(absDiff / hour);
            return `${hours}小时后`;
        } else if (yearTime === yearNow) {
            if (monthTime === monthNow) {
                if (dayTime === dayNow) {
                    return date.toLocaleTimeString(); // 当天不显示年月日
                } else {
                    return date.toLocaleTimeString('zh-CN', { hour: '2-digit', minute: '2-digit', second: '2-digit', day: '2-digit' }); // 当月不显示年月
                }
            } else {
                return date.toLocaleTimeString('zh-CN', { hour: '2-digit', minute: '2-digit', second: '2-digit', month: '2-digit', day: '2-digit' }); // 当年不显示年
            }
        } else {
            return date.toLocaleTimeString('zh-CN', { hour: '2-digit', minute: '2-digit', second: '2-digit', year: 'numeric', month: '2-digit', day: '2-digit' }); // 其他情况显示完整日期时间
        }
    }
}